import { getDomLoading } from './performanceListener';

const onDomLoading = response => {
  getDomLoading().then(domLoading => response(domLoading));
};

export default onDomLoading;
